import * as React from "react";
import { forwardRef } from "react";
const SvgReply = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-reply-icon lucide-reply", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M20 18v-2a4 4 0 0 0-4-4H4" }), /* @__PURE__ */ React.createElement("path", { d: "m9 17-5-5 5-5" }));
const ForwardRef = forwardRef(SvgReply);
export default ForwardRef;
